import React from "react";
import { Link, useLocation } from "react-router-dom";
import { analytics, EVENTS } from "../analytics";

const NavbarAbout: React.FC = () => {
  const location = useLocation();

  return (
    <nav className="bg-sub shadow-md border-b border-gray-300">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center h-12">
          <div className="flex space-x-8">
            <Link
              to="/about/results"
              onClick={() => analytics.track(EVENTS.CLICK_ABOUT_NAV_RESULTS)}
               className={`font-medium transition-colors ${
                location.pathname === "/about/results"
                  ? "text-accent border-b-2 border-accent"
                  : "text-main hover:text-hover"
              }`}
            >
              Results
            </Link>
            <Link
              to="/about/testimonials"
              onClick={() => analytics.track(EVENTS.CLICK_ABOUT_NAV_TESTIMONIALS)}
               className={`font-medium transition-colors ${
                location.pathname === "/about/testimonials"
                  ? "text-accent border-b-2 border-accent"
                  : "text-main hover:text-hover"
              }`}
            >
              Testimonials
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavbarAbout;
